module.exports = __webpack_public_path__ + "static/media/split-black.dba3be98.png";